<!-- src/views/profile.vue -->
<template>
  <div class="profile">
    <div class="profile-head">
      <div class="profile-main">
        <div class="profile-info" @click="!uuid && login()">
          <div class="user-info">
            <h1>{{ uuid ? userInfo.nickName : "点击登录" }}</h1>
            <span>{{
              uuid ? `手机号：${userInfo.phone}` : "立即登录，享更低折扣"
            }}</span>
            <div class="edit-doc" v-if="uuid">
              <img src="@/assets/images/icon-edit.png" alt="" />
              <span @click="setUserInfo">编辑资料</span>
            </div>
          </div>

          <div class="avatar-img">
            <img
              @click="!uuid && login()"
              class="avatar"
              :src="
                userInfo.userImg ||
                require('@/assets/images/default_avatar.png')
              "
              alt=""
            />
            <img
              v-if="uuid && vipLevel != 0"
              class="avatar-hat"
              :src="avatarInfo.hatUrl"
              alt=""
            />
            <img
              v-if="uuid && vipLevel != 0"
              class="avatar-level"
              :src="avatarInfo.levelUrl"
              alt=""
              @click="memberBenefitDialogVirsble = true"
            />
          </div>
        </div>

        <div class="profile-amount">
          <div class="amount">
            <span>{{ uuid ? userInfo.account : "0.00" }}</span>
            <span
              >我的余额<a class="detailed" v-if="uuid" @click="goBalance">
              (明细)
              </a></span
            >
          </div>
          <img
            @click="doOperate({ key: 'balanceRecharge' })"
            class="recharge"
            src="@/assets/images/recharge.png"
            alt=""
          />
        </div>
      </div>

      <div class="cell">
        <div class="coupon-and-points">
          <div
            class="cell-item coupon-cell-item"
            @click="doOperate({ key: 'coupon' })"
          >
            <div class="cell-item-container">
              <img
                :class="[
                  'icon-coupon',
                  userInfo.vipLevel >= 3 ? 'icon-level3' : '',
                ]"
                src="@/assets/images/icon-coupon.png"
                alt=""
              />
              <span class="coupon-label">我的优惠券</span>
            </div>
            <img
              class="arrow-coupon"
              src="@/assets/images/arrow-coupon.png"
              alt=""
            />
          </div>

          <div
            class="cell-item coupon-cell-item"
            @click="doOperate({ key: 'gamePoints' })"
            v-if="userInfo.vipLevel >= 3"
          >
            <div class="cell-item-container">
              <img
                :class="[
                  'icon-coupon',
                  'icon-points',
                  userInfo.vipLevel >= 3 ? 'icon-level3' : '',
                ]"
                src="@/assets/images/points-icon.png"
                alt=""
              />
              <span class="coupon-label">转游积分</span>
            </div>
            <img
              class="arrow-coupon"
              src="@/assets/images/arrow-coupon.png"
              alt=""
            />
          </div>
        </div>

        <div
          class="cell-item"
          v-for="item in cellList"
          :key="item.key"
          @click="doOperate(item)"
        >
          <div class="cell-item-container">
            <img class="cell-icon" :src="item.icon" alt="" />
            <span class="cell-span">{{ item.label }}</span>
          </div>
          <img class="arrow" src="@/assets/images/arrow.png" alt="" />
        </div>
      </div>
    </div>

    <customerDialog
      v-if="customerDialogVirsble"
      v-model="customerDialogVirsble"
      @handleClose="dialogClose"
    />
    <memberBenefitDialog
      v-if="memberBenefitDialogVirsble"
      v-model="memberBenefitDialogVirsble"
      :levelFlag="vipLevel"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import customerDialog from "@/components/CustomerDialog";
import memberBenefitDialog from "@/components/memberBenefitDialog"
import { requestMethods } from "@m/api";
export default {
  name: "profilePage",
  components: { customerDialog, memberBenefitDialog },
  data() {
    return {
      cellList: [
        {
          icon: require("@/assets/images/cell1.png"),
          label: "充值记录",
          key: "rechargeRecord",
        },
        {
          icon: require("@/assets/images/cell2.png"),
          label: "消息中心",
          key: "msgCenter",
        },
        {
          icon: require("@/assets/images/cell3.png"),
          label: "联系客服",
          key: "customer",
        },
        {
          icon: require("@/assets/images/cell4.png"),
          label: "常见问题",
          key: "problem",
        },
        {
          icon: require("@/assets/images/cell5.png"),
          label: "我的收藏",
          key: "myCollect",
        },
        {
          icon: require("@/assets/images/cell6.png"),
          label: "关于万梦",
          key: "aboutWM",
        },
      ],
      customerDialogVirsble: false,
      vipLevel: 0,
      memberBenefitDialogVirsble: false
    };
  },
  computed: {
    ...mapGetters(["userInfo", "uuid"]),
    avatarInfo() {
      if (this.vipLevel == 1) {
        return {
          hatUrl: require("@/assets/images/ic_special_vip_mine_1_2.png"),
          levelUrl: require("@/assets/images/ic_special_vip_mine_1_1.png"),
        };
      } else if (this.vipLevel == 2) {
        return {
          hatUrl: require("@/assets/images/ic_special_vip_mine_2_2.png"),
          levelUrl: require("@/assets/images/ic_special_vip_mine_2_1.png"),
        };
      } else if (this.vipLevel == 3) {
        return {
          hatUrl: require("@/assets/images/ic_special_vip_mine_3_2.png"),
          levelUrl: require("@/assets/images/ic_special_vip_mine_3_1.png"),
        };
      }
    },
  },
  mounted() {
    if (this.uuid) {
      this.getUserInfo();
      this.getSpecialVipLevel();
    }
  },
  methods: {
    ...mapActions(["updateUserInfo"]),
    login() {
      this.$router.push({ path: "/login" });
    },
    doOperate(scope) {
      switch (scope.key) {
        case "customer":
          this.customerDialogVirsble = true;
          break;

        default:
          this.$router.push({ path: `/${scope.key}` });
          break;
      }
    },
    dialogClose(action, done) {
      done();
    },
    goBalance() {
      this.$router.push({ path: "/balance" });
    },
    setUserInfo() {
      this.$router.push({ path: "/baseSetting" });
    },
    /**
     * 获取用户基本信息
     */
    async getUserInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getUserInfo.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        this.updateUserInfo(data);
      } catch (err) {
        this.$toast(err.message);
      }
    },

    /**
     * 获取用户vip等级
     */
    async getSpecialVipLevel() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/getSpecialVipLevel.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        this.vipLevel = data;
      } catch (err) {
        this.$toast(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-head {
  width: 750px;
  height: 351px;
  background: url("~@/assets/images/profile-bg.png");
  background-size: 100% 100%;
  padding: 124px 30px 35px 30px;
}
.profile-main {
  border-radius: 18px;
  box-shadow: 0px 0px 40px 0px rgba(200, 191, 187, 0.3),
    0px 4px 10px 0px rgba(149, 142, 139, 0.08);
}
.profile-info,
.profile-amount {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .detailed {
    // text-decoration: underline;
    border-bottom: 1px solid #333;
  }
}

.profile-info {
  width: 690px;
  height: 268px;
  background: url("~@/assets/images/info-bg1.png");
  background-size: 100% 100%;
  padding: 43px 40px 35px;

  .user-info {
    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 36px;
      color: #ff7a3e;
      margin-bottom: 26px;
      margin-top: 17px;
    }
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #8f8f8f;
    }
    .edit-doc {
      display: flex;
      align-items: center;
      margin-top: 30px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      span {
        font-weight: 400;
        font-size: 26px;
        color: #8f8f8f;
      }
    }
  }

  .avatar-img {
    position: relative;
    width: 190px;
    height: 190px;
    background: #f5f5f5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar {
    width: 156px;
    height: 156px;
    border-radius: 50%;
  }

  .avatar-hat {
    position: absolute;
    width: 69px;
    height: 55px;
    right: 9px;
    top: -19px;
  }
  .avatar-level {
    position: absolute;
    width: 145px;
    height: 50px;
    right: 16px;
    bottom: -15px;
  }
}
.profile-amount {
  width: 690px;
  height: 150px;
  background: url("~@/assets/images/info-bg2.png");
  background-size: 100% 100%;
  padding: 20px 40px;
  align-items: center;

  .amount {
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #000000;
      display: block;

      &:first-child {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 50px;
        color: #ff7a3e;
        line-height: 70px;
      }
    }
  }
  .recharge {
    width: 126px;
    // height: 60px;
  }
}
.cell {
  margin-top: 35px;
  padding-bottom: 98px;
  // padding: 0 50px 98px 40px;

  .cell-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-right: 20px;

    .cell-item-container {
      display: flex;
      align-items: center;

      .cell-icon {
        width: 90px;
        height: 90px;
        margin-right: 20px;
      }
      .cell-span {
        font-weight: 400;
        font-size: 30px;
        color: #000000;
      }
    }
    .arrow {
      width: 22px;
      height: 36px;
    }
  }
  .coupon-cell-item {
    background: url("~@/assets/images/coupon-bg.png");
    background-size: 100% 100%;
    height: 110px;

    .icon-coupon {
      width: 43px;
      height: 36px;
      margin-right: 43px;
      margin-left: 24px;
    }
    .arrow-coupon {
      width: 12px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .coupon-label {
    font-weight: 400;
    font-size: 28px;
    color: #792b2e;
  }

  .coupon-and-points {
    display: flex;
    align-items: center;

    .coupon-cell-item {
      flex: 1;

      &:last-child {
        margin-left: 8px;
      }

      .icon-level3 {
        margin-right: 2px;
      }

      .icon-points {
        width: 45px;
        height: 45px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/profile/index.vue